import A11yDialog from 'a11y-dialog'
$('.modalContainer').each(function(){
    var id = $(this).attr('id'); // make sure your modalContainer element has a unique ID
    var container = document.getElementById(id)
    var dialog = new A11yDialog(container)
    dialog.on('show', function (element, event) {
        $('body').addClass('__modal')
        // Do something on show
    })
    dialog.on('hide', function (element, event) {
        $('body').removeClass('__modal')
        // Do something on hide
        
    })
})

// Open the thank you modal if it exists
document.addEventListener('DOMContentLoaded', function () {
    const _enquiry_success = document.getElementById('enquiry_modal_success')

    if (_enquiry_success) {
        const dialog = new A11yDialog(_enquiry_success)
        dialog.show()
    }
})

// Open the enquiry modal if a link is #newEnquiry
$('a[href="#newEnquiry"]').on('click', function(e) {
    e.preventDefault()

    const _modal = document.getElementById('enquiry_modal')

    if (_modal) {
        const dialog = new A11yDialog(_modal)
        dialog.show()
    }
});
